<div class="sidenav" [ngClass]="{'wide': isWide(), 'small': !isWide()}">
  <div class="header">
    @if (isWide()) {
      Fetrapi Portal
    }
    <button (click)="toggleWide()">
      <i class="menuIcon ion ion-md-menu text-large align-middle"></i>
    </button>
  </div>

  <ul class="list-group">
    <li
        class="list-group-item list-group-item-action"
        routerLink="/approval"
        routerLinkActive="active-link"
        *policy="['ZOIPage']"
    >
      <i class="ion ion-md-globe"></i>
      @if (isWide()) {
        ZoI Data
      }
    </li>
    <li
      class="list-group-item"
      routerLink="/grid"
      routerLinkActive="active-link"
      *policy="['GridPage']"
    >
      <i class="ion ion-md-grid"></i>
      @if (isWide()) {
        Grid Data
      }
    </li>
    <hr/>
    <li
        class="list-group-item list-group-item-action"
        routerLink="/approval"
        routerLinkActive="active-link"
        *policy="['FetrapiAdmin']"
    >
      <i class="ion ion-md-list"></i>
      @if (isWide()) {
        Datasets
      }
    </li>
    <li
        class="list-group-item list-group-item-action"
        routerLink="/confirmation"
        routerLinkActive="active-link"
        *policy="['FetrapiAdmin']"
    >
      <i class="ion ion-md-checkbox-outline"></i>
      @if (isWide()) {
        Confirmation
      }
    </li>
    <li
        class="list-group-item list-group-item-action"
        routerLink="/consolidation"
        routerLinkActive="active-link"
        *policy="['AdminPage']"
    >
      <i class="ion ion-md-git-compare"></i>
      @if (isWide()) {
        Consolidation
      }
    </li>
    <li
        class="list-group-item list-group-item-action"
        routerLink="/log"
        routerLinkActive="active-link"
    >
      <i class="ion ion-md-book"></i>
      @if (isWide()) {
        Log
      }
    </li>
  </ul>
</div>
<!-- 
  <sidenav-router-link icon="ion ion-md-globe" route="/zoi" [active]="isActive('/zoi')" *policy="['ZOIPage']">ZoI Data</sidenav-router-link>
  <sidenav-router-link icon="ion ion-md-grid" route="/grid" [active]="isActive('/grid')" *policy="['GridPage']">Grid Data</sidenav-router-link>
  <div class="sidenav-divider my-0"></div>
  <sidenav-router-link icon="ion ion-md-list" route="/approval" [active]="isActive('/approval')" *policy="['FetrapiAdmin']">Datasets</sidenav-router-link>
  <sidenav-router-link icon="ion ion-md-checkbox-outline" route="/confirmation" [active]="isActive('/confirmation')" *policy="['FetrapiAdmin']">Confirmation</sidenav-router-link>
  <sidenav-router-link icon="ion ion-md-git-compare" route="/consolidation" [active]="isActive('/consolidation')" *policy="['AdminPage']">Consolidation</sidenav-router-link>
  <div class="sidenav-divider my-0"></div>
  <sidenav-router-link icon="ion ion-md-book" route="/log" [active]="isActive('/log')">Log</sidenav-router-link> 
 -->
